import { SCREEN_OVERLAY, SCREEN_SHOT } from './actionTypes';
export function sendSix15OverlayMessage(message) {
    // logger.info("sendSix15OverlayMessage:" + message)
    return {
        type: SCREEN_OVERLAY,
        six15_payload: message
    };
}
export function sendSix15ChatMessage(message) {
    // logger.info("sendSix15ChatMessage:" + message)
    return {
        type: "SEND_MESSAGE",
        message: message
    };
}
export function sendSix15ScreenshotMessage(message) {
    // logger.info("sendSix15ScreenshotMessage:" + message)
    return {
        type: SCREEN_SHOT,
        six15_payload: message
    };
}
